import { GET_VEHICALLIST_REQUEST, GET_VEHICALLIST_SUCCESS, GET_VEHICALLIST_FAIL,
    GET_DOCUMENTLIST_REQUEST, GET_DOCUMENTLIST_SUCCESS, GET_DOCUMENTLIST_FAIL, 
    CREATE_DOCUMENT_REQUEST, CREATE_DOCUMENT_SUCCESS, CREATE_DOCUMENT_FAIL, 
    UPLOAD_DOCUMENT_REQUEST, UPLOAD_DOCUMENT_SUCCESS, UPLOAD_DOCUMENT_FAIL,
    CHECK_VEHICLE_REQUEST, CHECK_VEHICLE_SUCCESS, CHECK_VEHICLE_FAIL } from '../types/documentTypes'

function checkVehicleReducer( state = { checkVehicle: [] }, action) {
    switch (action.type) {
        case CHECK_VEHICLE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CHECK_VEHICLE_SUCCESS: 
            return {
                ...state,
                checkVehicle: action.payload,
                isLoading: false
            }
        case CHECK_VEHICLE_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}
    

function editDocumentReducer( state = { uploadDocument: [] }, action) {
    switch (action.type) {
        case UPLOAD_DOCUMENT_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPLOAD_DOCUMENT_SUCCESS: 
            return {
                ...state,
                uploadDocument: action.payload,
                isLoading: false
            }
        case UPLOAD_DOCUMENT_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


function createDocumentReducer( state = { createDocument: {} }, action) {
    switch (action.type) {
        case CREATE_DOCUMENT_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_DOCUMENT_SUCCESS: 
            return {
                ...state,
                createDocument: action.payload,
                isLoading: false
            }
        case CREATE_DOCUMENT_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getVehicleListReducer( state = { vehicleList: [] }, action) {
    switch (action.type) {
        case GET_VEHICALLIST_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_VEHICALLIST_SUCCESS: 
            return {
                ...state,
                vehicleList: action.payload,
                isLoading: false
            }
        case GET_VEHICALLIST_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function getDocumentListReducer( state = { documentList: [] }, action) {
    switch (action.type) {
        case GET_DOCUMENTLIST_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_DOCUMENTLIST_SUCCESS: 
            return {
                ...state,
                documentList: action.payload,
                isLoading: false
            }
        case GET_DOCUMENTLIST_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}
export { getVehicleListReducer, getDocumentListReducer, editDocumentReducer , createDocumentReducer, checkVehicleReducer }